import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AudiPlatformProvider, FontWeight, Text, TypographyVariantLabels } from '@audi/audi-ui-react';
import { HTMLElement } from '@audi/audi-ui-react/dist/types/components/Text/Text.types';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-audi-text',
    template: ''
})
export class AudiTextComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://react.ui.audi/?path=/story/components-text-overview--page
    @Input() text = '';
    @Input() type = 'span'; // span, h1, etc.
    @Input() variant = '';
    @Input() weight = 'normal';
    @Input() className = '';

    ElementToShow = () => (
        <AudiPlatformProvider>
            <Text
                as={this.type as HTMLElement}
                variant={this.variant as TypographyVariantLabels}
                weight={this.weight as FontWeight}
                className={this.className} >
                {this.text}
            </Text>
        </AudiPlatformProvider>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('AudiTextComponent.ngOnChanges', changes);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('AudiTextComponent.ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('AudiTextComponent.ngOnDestroy');
        ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
